
import { AxiosRequestConfig } from 'axios';
import { CommonAxiosServiceWp }  from './common-axios-service-wp';
import { CompanyIdRequest, CompanyModel, CompanyResponse, GlobalResponseObject, ModuleIdRequest, ModuleModel, ModuleResponse } from '@schemax-whatsapp/shared-models';

export class ModuleService extends CommonAxiosServiceWp {
    private getURLwithMainEndPoint(childUrl: string) {
        return '/module/' + childUrl;
    }

    async createModule( request: ModuleModel, config?: AxiosRequestConfig): Promise<ModuleResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createModule'), request, config);
    }

    async editModule( request: ModuleModel, config?: AxiosRequestConfig): Promise<ModuleResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('editModule'), request, config);
    }

    async getAllModules(config?: AxiosRequestConfig): Promise<ModuleResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllModules'), null, config);
    }

    async deleteModule( moduleReq: ModuleIdRequest, config?: AxiosRequestConfig): Promise<ModuleResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('deleteModule'), moduleReq, config);
    }

}